import { Box, } from "@mui/material";

const LoadingGif = () => {

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 5,}}>
      <Box
        component="img"
        src="/icons/loading.gif"
        alt="Loading"
        sx={{
          width: "150px",
          height: "auto",
          mixBlendMode: "multiply",
        }}
      />
    </Box>
  );
};

export default LoadingGif;
